import classNames from 'classnames';
import { ContentBlock, FlexContainer, TimeLine, Txt, View } from 'components';
import { formatCurrency } from 'helpers/formatNumber';
import styles from './TenancyBlock.module.scss';

/**
 * TenancyBlock
 *
 * @return {JSX.Element}
 */
const TenancyBlock = ({
  className,
  title,
  price,
  dateStart,
  dateEnd,
  onClick,
  highlight,
}) => {
  return (
    <ContentBlock
      className={classNames(
        styles.TenancyBlock,
        highlight && styles.TenancyBlock__highlight,
        className,
        TenancyBlock.displayName
      )}
      onClick={onClick}
      noPadding
      column
      overflowHidden
    >
      <FlexContainer className={styles.Header}>
        <Txt>{title}</Txt>
      </FlexContainer>
      <FlexContainer className={styles.Body} gap column>
        <View className={styles.Row}>
          <Txt>£{formatCurrency(price)}</Txt>
          <Txt caption>/month</Txt>
        </View>
        <TimeLine
          className={styles.Row}
          dateStart={dateStart}
          dateEnd={dateEnd}
        />
      </FlexContainer>
    </ContentBlock>
  );
};

TenancyBlock.displayName = 'TenancyBlock';

export default TenancyBlock;
